<template>
  <ModalWrapper
    :show="showAgreement"
    modal-style="modal-terms"
    :showBtn="false"
  >
    <div>
      <p class="terms text-center font-24 ">{{ $t("terms-and-conditions") }}</p>
      <section>
        <p class="font-18 mb-3 font-warranty">
          {{ $t("warranty-policy") }}
        </p>
        <ol>
          <li class="mb-1">
            <span>{{ $t("general-remarks") }}:</span>
            <ol>
              <li>
                <span>{{ $t("old-company-name") }}</span>
                ({{ $t("hereinafter") }} <span>"Figorr"</span>)
                {{ $t("voluntary-manufacturers-warranty") }}
              </li>
              <li>
                {{ $t("content-scope-of-warranty") }}
              </li>
              <li>
                {{ $t("amendment-of-policy") }}
              </li>
              <li class="mb-3">
                {{ $t("additional-warranty") }}
              </li>
            </ol>
          </li>

          <li class="mb-1">
            <span>{{ $t("warranty.scope") }}</span>
            <ol>
              <li class="mb-3">
                {{ $t("warranty.scope_1") }}
              </li>
              <li class="mb-3">
                {{ $t("warranty.scope_2") }}
                <ol>
                  <li>
                    {{ $t("warranty.scope_2a") }}
                  </li>
                  <li>
                    {{ $t("warranty.scope_2b") }}
                  </li>
                  <li>
                    {{ $t("warranty.scope_2c") }}
                  </li>
                </ol>
              </li>
              <li class="mb-3">
                {{ $t("warranty.scope_3") }}
                <ol>
                  <li>
                    {{ $t("warranty.scope_3a") }}
                  </li>
                  <li>
                    {{ $t("warranty.scope_3b") }}
                  </li>
                  <li>
                    {{ $t("warranty.scope_3c") }}
                  </li>
                </ol>
              </li>
              <li class="mb-1">
                <span>{{ $t("warranty.warrantor") }}</span>
                <p class="mb-3">
                  {{ $t("warranty.warrantor_p") }}
                </p>
              </li>
              <li class="mb-3">
                <span>{{ $t("warranty.warranty_holder") }}</span>
                <ol>
                  <li class="mb-3">
                    {{ $t("warranty.warranty_holder_1") }}
                  </li>
                  <li class="mb-3">
                    {{ $t("warranty.warranty_holder_2") }}
                  </li>
                  <li class="mb-3">
                    {{ $t("warranty.warranty_holder_3") }}
                    <ol>
                      <li>
                        {{ $t("warranty.warranty_holder_3a") }}
                      </li>
                      <li>
                        {{ $t("warranty.warranty_holder_3b") }}
                      </li>
                      <li>
                        {{ $t("warranty.warranty_holder_3c") }}
                      </li>
                      <li>
                        {{ $t("warranty.warranty_holder_3d") }}
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li class="detail-list">
            <span class=" mb-1">{{ $t("warranty_claim") }}</span>
            <ol>
              <li class="mb-3">
                {{ $t("warranty_claim_1") }}
                <ol>
                  <li>
                    {{ $t("warranty_claim_1a") }}
                  </li>
                  <li>
                    {{ $t("warranty_claim_1b") }}
                  </li>
                  <li>
                    {{ $t("warranty_claim_1c") }}
                  </li>
                  <li>
                    {{ $t("warranty_claim_1d") }}
                  </li>
                </ol>
              </li>
              <li>
                {{ $t("warranty_claim_2") }}
              </li>
            </ol>
          </li>

          <li class="detail-list">
            <span class=" mb-1">{{ $t("warranty.period") }}</span>
            <ol>
              <li class="mb-3">
                {{ $t("warranty.period_1") }}
              </li>
              <li class="mb-3">
                {{ $t("warranty.period_2") }}
              </li>
              <li class="mb-3">
                {{ $t("warranty.period_3") }}
              </li>
            </ol>
          </li>

          <li class="detail-list">
            <span class="mb-1">{{ $t("warranty_exclusions") }}:</span>
            <p class="mb-3">
              {{ $t("warranty_claims_excluded") }}
            </p>
            <ol>
              <li>{{ $t("exclusion_reason_1") }}</li>
              <li>{{ $t("exclusion_reason_2") }}</li>
              <li>{{ $t("exclusion_reason_3") }}</li>
              <li>{{ $t("exclusion_reason_4") }}</li>
              <li>{{ $t("exclusion_reason_5") }}</li>
              <li>{{ $t("exclusion_reason_6") }}</li>
              <li>{{ $t("exclusion_reason_7") }}</li>
              <li>{{ $t("exclusion_reason_8") }}</li>
            </ol>
          </li>

          <li>
            <span class="mb-1">{{ $t("warranty_services") }}:</span>
            <ol>
              <li class="mb-3">
                {{ $t("warranty_claim_remedies") }}:
                <ol>
                  <li>{{ $t("remedy_option_1") }}</li>
                  <li>{{ $t("remedy_option_2") }}</li>
                  <li>{{ $t("remedy_option_3") }}</li>
                </ol>
              </li>
              <p class="mb-3">{{ $t("warranty_services_definition") }}</p>
              <li class="mb-3">
                {{ $t("warranty_remedy_determined_by_gricd") }}
              </li>
              <li class="mb-3">
                {{ $t("repair_on_warranty_holders_site") }}:
                <ol>
                  <li>{{ $t("repair_option_1") }}</li>
                  <li class="mb-3">{{ $t("repair_option_2") }}</li>
                </ol>
              </li>

              <li class="detail-list">
                {{ $t("repair_in_repair_center") }}:
                <ol>
                  <li>{{ $t("repair_center_option_1") }}</li>
                  <li>{{ $t("repair_center_option_2") }}</li>
                  <li>{{ $t("repair_center_option_3") }}</li>
                  <li>{{ $t("repair_center_option_4") }}</li>
                </ol>
              </li>
              <li class="mt-2 mb-3">{{ $t("warranty_services_costs") }}</li>
              <li class="mb-3">{{ $t("warranty_holder_responsibility") }}</li>
              <li class="mb-3">{{ $t("gricd_warranty_services_efforts") }}</li>

              <li class="mb-3">
                {{ $t("warranty_holder_acknowledges_delays") }}:
                <ol>
                  <li>{{ $t("delay_reason_1") }}</li>
                  <li>{{ $t("delay_reason_2") }}</li>
                  <li>{{ $t("delay_reason_3") }}</li>
                  <li>{{ $t("delay_reason_4") }}</li>
                </ol>
              </li>
              <li class="mb-3">{{ $t("gricd_delay_notification") }}</li>
            </ol>
          </li>
          <li class="mb-1">
            <span>{{ $t("warranty_extensions") }}:</span>
            <p class="mb-3">{{ $t("warranty_extensions_explanation") }}</p>
          </li>

          <li class="detail-list">
            <span class="mb-1"
              >{{ $t("claiming_services_under_warranty") }}:</span
            >
            <ol>
              <li class="mb-3">{{ $t("notify_gricd_of_warranty_claim") }}</li>
              <li class="mb-3">
                {{ $t("warranty_holder_provide") }}:
                <ol>
                  <li>{{ $t("provide_copy_of_agreement") }}</li>
                  <li>{{ $t("provide_sales_invoice") }}</li>
                  <li>{{ $t("provide_description_of_issue") }}</li>
                </ol>
              </li>
              <li>{{ $t("provide_further_information") }}</li>
              <li class="mb-3">{{ $t("failure_to_meet_requirements") }}</li>
            </ol>
          </li>

          <li class="mb-1">
            <span>{{ $t("applicable_law_jurisdiction_dispute") }}:</span>
            <ol>
              <li class="mb-3">{{ $t("subject_to_nigerian_law") }}</li>
              <li class="mb-3">{{ $t("dispute_resolution_clause") }}</li>
              <li>{{ $t("place_of_performance") }}</li>
            </ol>
          </li>
        </ol>
      </section>
      <div class="d-flex justify-content-center col-gap-1">
        <button
          type="button"
          @click="$emit('agreed')"
          class="btn btn-primary mt-4 mx-auto d-block px-5"
        >
          {{ $t("accept") }}
        </button>
        <button
          type="button"
          class="btn btn-secondary mt-4 mx-auto d-block px-5"
          v-if="dashboard"
          @click="$emit('logoutUser')"
        >
          {{ $t("decline") }}
        </button>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import ModalWrapper from "./ModalWrapper.vue";
export default {
  name: "Terms",
  props: {
    showAgreement: { type: Boolean, default: false },
    dashboard: { type: Boolean, default: false },
  },
  components: { ModalWrapper },
};
</script>

<style scoped>
/* .detail-list ul {
  padding-left: 30px;
}
.detail-list li {
  margin-bottom: 20px;
} */
.terms {
  margin-bottom: 2.5rem;
}
section {
  height: calc(100vh - 28rem);
  background: #f7f8f9;
  overflow-y: scroll;
  padding: 20px 75px;
}
@media (max-width: 767.98px) {
  section {
    height: calc(100vh - 23rem);
    padding: 10px 15px;
  }
  .terms {
    margin-bottom: 1rem;
  }
}

ol {
  counter-reset: item;
}
ol li {
  display: block;
  position: relative;
}
ol li:before {
  content: counters(item, ".") ".";
  counter-increment: item;
  position: absolute;
  margin-right: 100%;
  right: 10px; /* space between number and text */
}
li > span {
  font-weight: bold;
}
.font-warranty {
  font-weight: 600;
}
</style>
